import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { AuthenticationService } from './authentication.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    // Prevent multiple 401 redirects when several APIs fail at once
    private handling401 = false;

    constructor(public auth: AuthenticationService, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        // ✅ CRITICAL FIX FOR ANGULAR 19: Skip OPTIONS requests (CORS preflight)
        if (request.method === 'OPTIONS') {
            console.log('⚪ Skipping OPTIONS request (CORS preflight):', request.url);
            return next.handle(request);
        }

        // ✅ Skip Authorization for authentication endpoints (login, register, etc.)
        if (
          request.url.includes("/public/industries") ||
          request.url.includes("/stripe/create-customer-portal-session") ||
          request.url.includes("/accounts/upgrade/payment-link") ||
          request.url.includes("/management-portal-0.0.1-SNAPSHOT/api/") ||
          request.url.includes("/users/reset-password/init") ||
          request.url.includes("/customer-users/reset-password/init") ||
          request.url.includes("/callback") ||
          request.url.includes("/customer-portal-config/master") ||
          request.url.includes("amazonaws.com") || //this is the url that stores images of logo for customer portal config
          request.url.includes("/open/qbo/config/disable")
        ) {
          console.log("⚪ Skipping auth for public endpoint:", request.url);
          return next.handle(request).pipe(catchError((err: any) => this.handleHttpError(err)));
        }

        let token: string = this.auth.getToken();
        
        // ✅ If no token, skip adding Authorization header
        if (!token || token === '' || token === 'null' || token === 'undefined') {
            console.log('⚠️ No token available, proceeding without Authorization header');
            return next.handle(request).pipe(catchError((err: any) => this.handleHttpError(err)));
        }
        
        console.log('🔵 Interceptor entered for:', request.method, request.url);
        
        var req = request.clone({
            setHeaders: {
                Accept: request.url.includes('export-csv') ? 'text/csv' : 
                        request.url.includes('export-pdf') ? 'application/pdf' : 
                        request.url.includes('export-excel') ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 
                        'application/json',
                Authorization: `Bearer ${token}`
            }
        });

        

        return next.handle(req).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    console.log('✅ Response received:', event.status, request.url);
                }
            }),
            catchError((err: any) => this.handleHttpError(err))
        );
    }

    /**
     * Log CORS/network failures without wiping the session.
     * Status 0 is the browser hiding the real response (CORS, downtime, mixed content) —
     * treating it as 401 logs users out and crashes the dashboard.
     */
    private handleHttpError(err: any): Observable<never> {
        if (err instanceof HttpErrorResponse) {
            if (err.status === 0) {
                console.error('❌ Server is down or CORS issue detected!');
                console.error('Request details:', {
                    method: err.url,
                    status: err.status
                });
            }

            if (err.status === 401) {
                debugger;
                this.forceLogoutOn401();
            }
        }
        return throwError(() => err);
    }

    private forceLogoutOn401(): void {
        if (this.handling401) {
            debugger
            return;
        }

        const currentUrl = this.router.url || '';
        if (currentUrl.startsWith('/login') || currentUrl.startsWith('/moqa-login')) {
            localStorage.clear();
            sessionStorage.clear();
            return;
        }

        this.handling401 = true;
        console.warn('⚠️ Unauthorized (401) - Forcing logout and redirect to login');

        try {
            localStorage.clear();
            sessionStorage.clear();
        } catch (e) {
            // ignore storage errors
        }
        window.location.href = '/login';
    }
}